<script lang="ts" setup>
const { $t } = useI18n()

const cards = [
  {
    key: 'invoice',
    title: String($t('components.bitbeli.widgetPromotionCards.invoice')),
    img: '/img/macbook-2.webp',
    href: '/platba-faktur-kryptomenami',
  },
  {
    key: 'company',
    title: String($t('components.bitbeli.widgetPromotionCards.company')),
    img: '/img/macbook.webp',
    href: '/nakup-kryptomen-na-firmu',
  },
  {
    key: 'whitelabel',
    title: String($t('components.bitbeli.widgetPromotionCards.whitelabel')),
    img: '/img/tablet-tower.webp',
    href: '/smenarensky-software',
  },
]
</script>

<template>
  <div mt-32px mx-auto max-w-5xl flex flex-col lg:flex-row gap-32px justify-between mb-32px>
    <FCard v-for="card in cards" :key="card.title" :card="card" />
  </div>
</template>
